module.exports = __webpack_public_path__ + "img/orderSummary 1.a51b1362.png";